export default __webpack_public_path__ + "static/media/facebook.ca35b1f8.svg";